var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:('background-image:url('+_vm.slide.image+')'),attrs:{"data-type":_vm.slide.type}})}
var staticRenderFns = []

export { render, staticRenderFns }